import React, { useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Input, Toast } from "antd-mobile";
import API from "@/api";
import useCustomTranslation from "@/hooks/useTranslation";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import { getUserInfoMethod } from "@/redux/reducers/authSlice";

const InvitationCode: React.FC<{
	onVisiblePopup: (visible: boolean) => void;
}> = ({ onVisiblePopup }) => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const [value, setValue] = useState("");

	// remake/备注 需要配合config中 agent下的applyBalance来判断是否调用
	const postUserAgentApplyHandle = async () => {
		try {
			const result: any = await API.members.postUserAgentApply({
				remake: value,
			});
			if (result?.code === 0) {
				dispatch(getUserInfoMethod());
				// 更新用户信息，进入管理或者在申请
				Toast.show({
					content: t("SubmittedSucce"),
					position: "top",
				});
			}
		} catch (error) {
			console.log("---postUserAgentApply--:", error);
		}
	};

	const onSubmit = () => {
		// 判断是否可以调用
		postUserAgentApplyHandle();
		onVisiblePopup(false);
	};

	return (
		<div className={classes.invitationCodeWrap}>
			<h2>{t("InputInvitationCode")}</h2>
			<div className="inputWrap">
				<Input
					placeholder={t("InvitationCode")}
					value={value}
					onChange={(val) => {
						setValue(val);
					}}
					style={{
						height: pxToRem(50),
						width: pxToRem(250),
						borderRadius: pxToRem(8),
						"--color": "#FFFFFF",
						"--text-align": "center",
						backgroundColor: "#181A22",
					}}
				/>
			</div>
			<Button
				onClick={onSubmit}
				block
				shape="rounded"
				style={{
					height: pxToRem(50),
					fontSize: pxToRem(16),
					fontWeight: "700",
					"--border-width": "0",
					"--text-color": "#FFFFFF",
					background:
						" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
				}}
			>
				{t("ApplyStarting")}
			</Button>
		</div>
	);
};

export default InvitationCode;

const useStyles = createUseStyles({
	invitationCodeWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(38),
			top: pxToRem(20),
		},
		background: "linear-gradient(to bottom right, #181B24 0, #232C48 100%)",
		"& h2": {
			color: "#FFFBEE",
			fontSize: pxToRem(18),
			fontWeight: "500",
			lineHeight: pxToRem(28),
			textAlign: "center",
		},
		"& .inputWrap": {
			display: "flex",
			justifyContent: "center",
			padding: {
				top: pxToRem(15),
				bottom: pxToRem(18),
			},
		},
	},
});
